module.exports = ".bottom {\n  margin-bottom: 0px;\n  padding-bottom: 2px; }\n"